import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Card, Avatar, Link,
// alpha,
 } from '@mui/material';
import { styled } from '@mui/system';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Label1, Label2 } from '../../atoms/typography';
import { hexToRgb } from '../../../utils';
const StyledUploadCard = styled('label') `
  position: relative;
  flex: 1 1 auto;
  cursor: pointer;
  #drag-file-element {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .MuiPaper-root {
    ${({ hasError, theme }) => hasError &&
    `border-color: ${theme.palette.error};`}
    border-style: ${({ hasError }) => !hasError ? `dashed` :
    `solid`};
    display: flex;
    flex-direction: column;
    align-items: center;
    ${({ hasError, theme }) => hasError &&
    `background-color: rgba(${hexToRgb(theme.palette.error.main)}, ${theme.palette.action.hoverOpacity});`}
    &:hover, &.drag-active {
      background-color: ${({ hasError, theme }) => hasError ?
    `rgba(${hexToRgb(theme.palette.error.main)}, ${theme.palette.action.hoverOpacity});` :
    `rgba(${hexToRgb(theme.palette.primary.main)}, ${theme.palette.action.selectedOpacity});`}
  }
`;
;
const UploadCard = ({ accept = '*', hasError = false, handleDrag, dragActive, multiple = false, onFileAdd, position, supportedFilesText, }) => (_jsxs(_Fragment, { children: [_jsx("input", { style: { display: 'none' }, type: 'file', accept: accept, id: 'upload-file', onChange: event => onFileAdd(event, position), multiple: multiple }), _jsxs(StyledUploadCard, { hasError: hasError, htmlFor: 'upload-file', onDragEnter: handleDrag, onDragLeave: handleDrag, children: [_jsxs(Card, { className: dragActive ? 'drag-active' : '', variant: 'outlined', elevation: 0, sx: {
                        py: 1.5,
                        px: 1,
                        gap: .5,
                    }, children: [_jsx(Avatar, { sx: { bgcolor: 'transparent' }, children: _jsx(UploadFileIcon, { color: hasError ? 'error' : 'primary' }) }), _jsxs(Label1, { children: [_jsx(Link, { children: "Browse files" }), _jsx("span", { children: ` or drag and drop to upload` })] }), _jsx(Label2, { color: 'text.secondary', children: supportedFilesText }), hasError &&
                            _jsx(Label2, { color: 'error.main', children: `Unsupported file` })] }), dragActive && _jsx("div", { id: "drag-file-element", onDragEnter: handleDrag, onDragLeave: handleDrag, onDragOver: handleDrag, onDrop: event => onFileAdd(event, position) })] })] }));
export default UploadCard;
//# sourceMappingURL=UploadCard.js.map